export const tracking = {
    app: 'REG',
    step: {
        init: 'INIT',
    },
};
